import React from 'react';

import styled from "styled-components";

const Button = styled.button`
    
  border-radius: 3px;
  padding: 14px 20px;
  background-color: #0080e2;
  font-weight: 900;
  font-size: 17px;
  line-height: 23px;
  text-align: center;
  color: #FFFFFF;

`;

export {Button};
